import { isDefined } from '@morpho-org/morpho-ts'
import { formatters, getDigitsFromPrice, getOraclePriceLabel } from '@morpho-org/ui-v6/utils'

import { getOracleProcedureWarnings } from '@/helpers/warnings'

import type { MarketOracles } from '../oracles.contract'

/** The oracle and DefiLlama prices, value secured and warnings shown in the oracle summary. */
export function toOracleSummary({ oracle, loanToken, collateralToken, warnings }: MarketOracles) {
  const collateralPrice = collateralToken?.priceUsd
  const loanPrice = loanToken.priceUsd

  const marketPrice = (() => {
    if (!collateralPrice || !isDefined(loanPrice)) return '—'

    const price = collateralPrice / loanPrice
    const priceString = formatters.commas
      .digits(getDigitsFromPrice(price))
      .trailingZero(false)
      .of(price)

    return `1 ${collateralToken.symbol} = ${priceString} ${loanToken.symbol}`
  })()

  const oraclePrice = getOraclePriceLabel({
    collateralAsset: collateralToken,
    loanAsset: loanToken,
    price: oracle?.price
  })

  const valueSecured = formatters.short
    .digits(2)
    .unit('$')
    .default('—')
    .trailingZero(false)
    .of(oracle?.valueSecuredUsd ?? undefined)

  return {
    marketPrice,
    oraclePrice,
    valueSecured,
    oracleWarnings: getOracleProcedureWarnings(warnings)
  }
}
